import { Route } from "react-router";

import ProductRecommendationsStep from "./components/ProductRecommendationsStep/ProductRecommendationsStep";
import ProjectInsulationStep from "./components/ProjectInsulationStep/ProjectInsulationStep";
import RoomDetailsStep from "./components/RoomDetailsStep/RoomDetailsStep";
import { SelectionGuideLayout } from "./components/SelectionGuideLayout/SelectionGuideLayout";

export const selectionGuideRoutes = () => {
  return (
    <Route
      path="/projects/:projectId/rooms/:roomId/selection-guide"
      Component={SelectionGuideLayout}
    >
      <Route path="room" Component={RoomDetailsStep} />
      <Route path="insulation" Component={ProjectInsulationStep} />
      <Route path="recommendations" Component={ProductRecommendationsStep} />
      <Route index Component={ProjectInsulationStep} />
    </Route>
  );
};
